





















































import {Component, Vue} from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue"
import YcAside from "@/components/common/yc-aside.vue"
import {TFenqunDetailVO} from "@/model/TFenqunVO";
import FlowBox from "@/components/flow/flow-box.vue";
import FlowRelation from "@/components/flow/flow-relation.vue";
import {getFenqunDetail, getFlowConfig, saveFenqunDetail, getSuggestList} from "@/services/api"
import {FlowConfigVO} from "@/model/FlowConfigVO";
import store from "@/store";
import {getConfigTips} from "@/services/config";

@Component({
  components: {
    'yc-aside': YcAside,
    'yc-header': YcHeader,
    'yc-flow-box': FlowBox,
    'yc-flow-relation': FlowRelation
  },
})
export default class UserGroupingSetting extends Vue {
  public fenqunDetail: TFenqunDetailVO | null = null;
  public config: FlowConfigVO | null = null;
  creating = false;
  public rules = {
    name:[{ required: true, message: '请输入用户群名称', trigger: 'blur' }, {max: 200, message: '长度不能超过200个字符', trigger: 'blur' }],
  }

  public fenqunCleanFlag = false;
  emailCleaning = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.emailCleaning;
  opEmail = JSON.parse(localStorage.getItem('displayInfo') || '{}')?.email;
  isShow = ['test30_01@cartx.ai', 'test531@cartx.cloud','test532@cartx.cloud','test482@cartx.cloud', 'test403@cartx.cloud', 'test467@cartx.cloud', 'test468@cartx.cloud', 'test472@cartx.cloud', 'test531@cartx.cloud', 'test530@cartx.cloud', 'test33@cartx.cloud', 'test533@cartx.cloud', ' test537@cartx.cloud'].includes(this.opEmail) && this.emailCleaning

  async created(): Promise<void> {
    await getFlowConfig({}, true)
      .then(res => {
        let i = res.data.data.eventFields?.SHOPIFY_PLACED_ORDER?.findIndex((item) => {
          return item.en ==='financial_status'
        })
        if (i > 0) {
          res.data.data.eventFields?.SHOPIFY_PLACED_ORDER.splice(i,1)
        }
        this.config = res.data.data;
        this.config.timeFunctions = this.config.timeFunctions?.filter(res => res.en !== 'INFLOW');
        this.config = getConfigTips(this.config);
      })
    const id = this.$route.params.id;
    if(id) {
      this.getFenqunDetail(parseInt(id))
    } else {
      this.fenqunDetail = {
        "relation": "AND",
        "rules": [
          {
            "type":"EVENT",
            "relation":"AND",
            'strictType': 'PROPERTY_STRICT',
            "filters":[{
              "type":"FILTER",
              "field":"",
              "operator":"",
              "value": []
            }]
          },
          {
            "type": "RELATION",
            'strictType': 'ACTION_STRICT',
            "relation": "AND",
            "rules": [{
              "timeParams": [],
              "timeFunction": "",
              "type": "EVENT",
              "eventName": "",
              "relation": "AND",
              "filters": [],
              "measure": {
                "field": "",
                "value": []
              },
              "windowDo": ""
            }]
          }
        ]
      }
    }
    this.getSuggestList();
    // console.log(this.fenqunDetail, 'this.fenqunDetail')
  }

  /**
   * 联想列表（用于预加载）
   */
  getSuggestList() {
    ['items','collections','flow_name','strategy_name','campaign_name','subject_content','bounce_type'].forEach(type => {
      Object.keys(this.$store.state.suggestMap).indexOf(type) === -1 &&
      getSuggestList({type}).then(res => {
        store.commit('SET_SUGGEST_MAP', {key: type, value: res.data.data||[]});
      })
    })
  }

  removeIdFrom(array: any[]) {
    array.forEach(rule => {
      delete rule.id;
      if (rule.filters) {
        this.removeIdFrom(rule.filters);
      }
      if (rule.rules) {
        this.removeIdFrom(rule.rules);
      }
    })
  }

  getFenqunDetail(id: number) {
    getFenqunDetail({id})
      .then(res => {
        this.fenqunDetail = res.data.data;
        // 0506动态分群复制，进入详情页
        if (this.$route.query.copy) {
          // 直接走新建程序就可以了
          delete this.fenqunDetail.id;
          this.fenqunDetail.name = `副本：${this.fenqunDetail.name}`;
          if (this.fenqunDetail.rules) {
            this.removeIdFrom(this.fenqunDetail.rules)
          }
        }
      })
  }

  saveFenqunDetail() {
      const fenqunName: any = this.$refs.fenqunName;
      let res = false;
      fenqunName.validate((valid: boolean) => {
        return (res = valid);
      });
      if (!res) {
        const nameEl: any = this.$refs.nameEl;
        nameEl.focus();
        return;
      }
      if (this.creating) {
        return;
      }
      this.creating = true;
      // 用户流程校验提示, 验证未填写完整的数据
      // 用户属性满足
      const detail: any = this.fenqunDetail;
      const propertyStrict = detail.rules.find((x: any) =>x.strictType === "PROPERTY_STRICT");
      const excludeOperator = ['ASTRUE', 'ASFALSE', 'HAS', 'HASNOT', 'ALLTIME']; // 剔除必有值项
      const excludeType = ["DYNAMIC", "ABSOLUTE", "ATLAST", "ATLASTBEFFORE", "BETTEN"]; // 验证两个值
      // 暂时先封装了一个方法
      const validateProperty = (x : any) => {
        return !(!x?.field && (!x?.value?.length && !excludeOperator.includes(x?.operator))) && !((!!x?.field && (!excludeType.includes(x?.operator) ? (!!x?.value?.length || excludeOperator.includes(x?.operator)) : (x?.value?.length === 2 && !x?.value?.some((x : any) => typeof x === 'undefined' || x === ""))))) || (!!x?.field && x?.value?.some((x: any) => typeof x === 'undefined' || x === '' || x === null));
      }
      const propertyInvalid = propertyStrict.filters.some((x: any) => validateProperty(x));
      // 用户行为满足 过滤全空事件
      const actionStrict = detail.rules.find(
        (x: any) => x.strictType === "ACTION_STRICT"
      ).rules;
      // const actionInvalid = actionStrict.some((x: any) =>(!x.timeFunction || !x.eventName || !x?.windowDo) && !(!x.timeFunction && !x.eventName && !x?.windowDo)) || actionStrict.filter((x: any) =>!excludeType.includes(x.timeFunction)).some((x: any) =>[...x.filters, x.measure].some((x: any) => validateProperty(x))) || actionStrict.filter((x: any) =>excludeType.includes(x.timeFunction)).some((x: any) =>((!x.eventName || !x?.windowDo || x.timeParams.length < 2) && !(!x.eventName && !x?.windowDo && x.timeParams.length === 2)) || [...x.filters, x.measure].some((x: any) => validateProperty(x)));
      // if (propertyInvalid || actionInvalid) {
      //   this.$message.error("添加了无效的筛选条件，请重新设置或删除");
      //   return;
      // }
      // 检测是否有有效值 属性条件 2选一  //TODO by V.K
      const propertyOnlyInvalid = !propertyStrict.filters.some((x: any) => excludeOperator.includes(x.operator) || (x.field && x.value?.length));
      const actionOnlyInvalid = !actionStrict.some((x: any) => x.timeFunction && x.eventName && x?.windowDo);
      if (propertyOnlyInvalid && actionOnlyInvalid) {
        this.$message.error("请至少添加一项用户属性或用户行为筛选条件");
        this.creating = false;
        return;
      }
      // 过滤未填写数据进行提交
      const propertyValidData = propertyStrict.filters.filter((x: any) => excludeOperator.includes(x.operator) || ((x.field && x.value.length)));
      const actionValidData = actionStrict.filter((x: any) => x.timeFunction || x.eventName || x?.windowDo).map((x: any) => {
        return {
          ...x,
          filters: x.filters.filter((x: any) => !!x.field),
        }
      });

      const propertyIndex = detail.rules.findIndex((x: any) => x.strictType === "PROPERTY_STRICT");
      const actionIndex = detail.rules.findIndex((x: any) => x.strictType === "ACTION_STRICT");

      detail.rules[propertyIndex].filters = propertyValidData;
      detail.rules[actionIndex].rules = actionValidData;

    detail.fenqunCleanFlag = +this.fenqunCleanFlag;
    detail.email = this.opEmail;
      saveFenqunDetail(detail, true).then((res) => {
        this.$message.success("保存成功");
        // this.$router.push("");
        window.location.href = '/cartsee-new/user/grouping'
        this.creating = false;
      }).catch(()=>{
        this.creating = false;
      });
    }

  /**
   * 取消
   */
  async cancel() {
    await this.$confirm(
      "确定放弃当前编辑吗？已配置内容将不再保存！",
      "确定放弃编辑吗？",
      {
        customClass:'modalOk',
        confirmButtonText: '放弃编辑',
        cancelButtonText: '继续编辑'
      });
      window.location.href = '/cartsee-new/user/grouping'
  }

}
